import * as types from "./mutation-types";
const mutations = {
  [types.SET_SAVE_userInfo](state, obj) {
    state.userInfo = obj;
  },
  [types.SET_SAVE_lang](state, str) {
    state.lang = str;
  },
  [types.SET_SAVE_sideBarList](state, ary) {
    state.sideBarList = ary;
  },
  [types.SET_SAVE_sideBarListEN](state, ary) {
    state.sideBarListEN = ary;
  }
};
export default mutations;
